class Dropdown {
  trigger: NodeListOf<Element>;
  constructor() {
    this.trigger = document.querySelectorAll('[data-trigger="dropdown"]');
    if(this.trigger){
      this._init();
    }
  }
  
  _init() {
    this.trigger.forEach(element => {
      element.addEventListener('click', () => {
        const isActive: boolean = element.classList.contains('active');
        if(isActive){
          element.classList.remove('active');
        }else{
          element.classList.add('active');
        }
      });
    });
    const elements = this.trigger;
    window.addEventListener("resize", () => {
      if (window.innerWidth > 1280) {
        this.trigger.forEach(element => {
          element.classList.remove('active');
        });
      }
    });
  }
}
export let dropdown = new Dropdown();
